<app-item [entity]="pain" [deleteService]="!hideButtons ? deleteService : undefined" [deleteButtonInMore]="true">

    <app-luna-button more-buttons  *ngIf="!hideButtons" iconName="pencil" (clickedEvent)="update()"></app-luna-button>

    <app-summary [expandable]="true">
        <div title>
            <ng-container *ngIf="titleDisplay === 'title'">
                Douleur
            </ng-container>
            <ng-container *ngIf="titleDisplay === 'date'">
                <app-date-label [date]="pain.date"></app-date-label>
            </ng-container>
        </div>
        <ng-container expandedContent>

            <ng-container *ngIf="pain.locations?.length > 0">
                <div class="d-flex gap flex-wrap align-items-center">
                    <ng-container *ngFor="let location of pain.locations">
                        <app-lov-value-summary-field *ngIf="location.lovValue" [lovValueSummary]="location.lovValue"></app-lov-value-summary-field>
                        <app-summary-field *ngIf="location.customValue" [value]="location.customValue"></app-summary-field>
                    </ng-container>
                </div>
            </ng-container>
            <ng-container *ngIf="pain.whens?.length > 0">
                <div class="d-flex gap flex-wrap align-items-center">
                    <ng-container *ngFor="let when of pain.whens">
                        <app-lov-value-summary-field *ngIf="when.lovValue" [lovValueSummary]="when.lovValue"></app-lov-value-summary-field>
                        <app-summary-field *ngIf="when.customValue" [value]="when.customValue"></app-summary-field>
                    </ng-container>
                </div>
            </ng-container>
            <ng-container *ngIf="pain.hows?.length > 0">
                <div class="d-flex gap flex-wrap align-items-center" >
                    <ng-container *ngFor="let how of pain.whens">
                        <app-lov-value-summary-field *ngIf="how.lovValue" [lovValueSummary]="how.lovValue"></app-lov-value-summary-field>
                        <app-summary-field *ngIf="how.customValue" [value]="how.customValue"></app-summary-field>
                    </ng-container>
                </div>
            </ng-container>
            <div *ngIf="pain.from || pain.to">
                <app-custom-date-field [from]="pain.from" *ngIf="pain.to"></app-custom-date-field>
            </div>
            <div class="d-flex gap align-items-center flex-wrap" *ngIf="pain.lastIntensity">
                <app-date-summary-field *ngIf="pain.lastIntensity.date" [date]="pain.lastIntensity.date"></app-date-summary-field>
                <app-rating [rating]="pain.lastIntensity.intensity" [maxRating]="10"></app-rating>
            </div>
            <div *ngIf="pain.comment" [innerHTML]="pain.comment"></div>
        </ng-container>
    </app-summary>
</app-item>
